import type { UserRole } from "@/types/api";

/**
 * Destinos de navegacao por papel.
 *
 * Em modulo proprio, e nao junto dos guards, porque um arquivo que exporta
 * componentes e funcoes ao mesmo tempo quebra o Fast Refresh do Vite: uma
 * edicao no guard remontaria a arvore inteira em vez de trocar so o
 * componente.
 */
export function homeForRole(role: UserRole | "operator" | null | undefined): string {
  switch (role) {
    case "therapist":
      return "/painel";
    case "guardian":
      return "/";
    case "operator":
      return "/admin";
    default:
      return "/entrar";
  }
}
